<template>
  <App :showHeader="false" :showFooterTabBar="!loading" activeName="workbench">
    <header id="header" v-if="!loading">
      <div class="header-container">
        <div class="header-left">
          <div class="avator">
            <img
              src="../../assets/images/icon/icon_avator@2x.png"
              @click="toPerson"
            />
          </div>
          <span class="name">Hello,{{ curUser.name }}</span>
        </div>
        <!-- <div
          class="header-right"
          v-auth="'workbench-SearchList'"
          @click="goSearch"
        >
          <img
            class="icon_search"
            src="../../assets/images/icon/icon_search@2x.png"
          />
        </div> -->
      </div>
    </header>
    <div class="container" >
      <Card title="Sales Funnel">
        <Label :labelData="{ list: rankLable }" @onChange="timeChange" />
        <div id="mainChart" style="width: 100%; height: 300px"></div>
      </Card>
      <!-- <Card class="car">
        <div class="carItem" @click="unAllot('/orderList')">
          <div class="car-item-left">
            <img src="../../assets/images/icon/unclue@2x.png" alt="" />
            <span class="car-text">Orders</span>
          </div>
        </div>
      </Card> -->
      <!-- 跟进模块 -->
      <Card
        v-for="(item, index) in cardList"
        :key="index + '1'"
        v-auth="item.authCode"
        :title="item.title"
        :span="item.span"
        :currentIdentity="currentIdentity"
        :border="item.border"
        :labelColor="item.labelColor"
        :dataList="item.data"
      />
    </div>
  </App>
</template>
<script>
/* eslint-disable */
import Card from "./components/card/index";
import Rank from "./components/rank/index";
import Label from "_c/label";
import { functionList, createRenderItem, rankLable } from "./attr";
import { getBrandCity } from "@/api/chargequery/index";
import { Toast, Icon, Button } from "vant";
import {
  unDistribution,
  getTaskNum,
  getRank,
  getSalesFunnelStatistics,
} from "@/api/workbench/index";
import * as echarts from "echarts";
// function tranfFormDate (valKey, data = "0") {
//   try {
//     return valKey
//   } catch {
//     return data;
//   }
// }
export default {
  name: "workbench",
  components: {
    Card,
    Rank,
    Label,
    Icon,
    Button,
  },
  data() {
    return {
      loading: true,
      uid: "",
      curUser: {},
      roleCode: "", // 角色code
      currentIdentity: "org", // 当前查看的是自己还是组织的self/org
      rankDate: "month", // 战绩排名月周日参数
      unDistribution: {}, // 未分配数量
      common: [
        {
          title: "常用功能",
          labelColor: "#333",
          border: false,
          data: functionList,
        },
      ],
      rankList: [],
      cardList: [],
      Statistics: {},
      myChart: null
    };
  },
  computed: {
    rankLable() {
      return rankLable;
    },
    roleCodename() {
      return this.roleCode === "RE005"
        ? "Outlet"
        : this.roleCode === "RE004"
        ? "Dealer"
        : "";
    },
  },
  methods: {
    xiaobai() {
      this.$router.push({ path: "/sharePosters" });
    },
    // 跳转到搜索页面
    goSearch() {
      this.$router.push({ path: "/allSearch" });
    },
    // 获取未分配数量
    async getUnDistribution() {
      const res = await unDistribution();
      if (res.success) {
        // console.log('---', res.data);

        this.unDistribution = res.data;
      } else {
        Toast(res.msg);
      }
    },
    // 获取上牌城市
    async getBrandCity() {
      const { data, code } = await getBrandCity();
      if (this.$store.state.app.constant["successCode"] === code) {
        this.cityName = data;
      } else {
        this.$Message.error(this.$store.state.app.constant["40000"]);
      }
    },
    // 获取购车人信息
    async getAccountDetail() {
      const { data, code } = await accountDetail({
        id: this.$route.query.accoundId,
      });
      if (this.$store.state.app.constant["successCode"] === code) {
        this.accountDetail = data;
      } else {
        this.$Message.error(this.$store.state.app.constant["40000"]);
      }
    },
    roleChange(item) {
      this.currentIdentity = item;
      this.getTaskNum();
    },
    // 获取跟进任务数量
    async getTaskNum() {
      const res = await getTaskNum({ currentIdentity: this.currentIdentity });
      if (res.success) {
        this.cardList = [
          {
            title: "Leads",
            span: 3,
            authCode: "workbench-FollowUpTask",
            data: [
              {
                label: "To follow up today",
                value: createRenderItem(
                  res.data.leadsTodyCount,
                  `Overdue: ${res.data.leadsTodyOverdueCount}`
                ),
                path: "/cluesFollowUp",
                query: "followUp",
              },
              {
                label: "To  Contact",
                value: res.data.leadsAttemptingTouchingCount,
                path: "/cluesFollowUp",
                query: "contact",
              },
              {
                label: "Dormant",
                value: res.data.leadsHibernateCount,
                path: "/cluesFollowUp",
                query: "dormancy",
              },
            ],
          },
          {
            title: "Prospects",
            authCode: "workbench-FollowUpTask",
            data: [
              {
                label: "To follow up today",
                value: res.data.oppTodyCount,
                path: "/businessOpportunitiesFollowUp",
                query: "followUp",
              },
              {
                label: "Close Date",
                value: res.data.oppClosedateCount,
                path: "/businessOpportunitiesFollowUp",
                query: "closeDate",
              },
              {
                label: "Open for  89+ days",
                value: res.data.opp89UnorderCount,
                path: "/businessOpportunitiesFollowUp",
                query: "unsettled",
              },
              {
                label: "Dormant",
                value: res.data.oppHibernateCount,
                path: "/businessOpportunitiesFollowUp",
                query: "dormancy",
              },
            ],
          },
          // {
          //   title: '订单跟进',
          //   span: 3,
          //   authCode: 'workbench-FollowUpTask',
          //   data: [
          //     { label: '大定已付待跟进', value: res.data.orderDepositPaidCount, path: '/orderFollowUp', query: 'largeSet' },
          //     { label: '待Hand-over', value: res.data.orderHandOffCount, path: '/orderFollowUp', query: 'handOff' },
          //     { label: '意向金退款待跟进', value: res.data.orderDRRefundCount, path: '/orderFollowUp', query: 'intentionGold' }
          //   ]
          // },
          // {
          //   title: '试驾跟进',
          //   authCode: 'workbench-FollowUpTask',
          //   data: [
          //     { label: '今日试驾', value: res.data.testDriveTodyCount, path: '/testDriveFollowUp', query: 'followUp' },
          //     { label: 'PDC', value: res.data.testDrivePdcCount, path: '/testDriveFollowUp', query: 'PDC' },
          //     { label: 'TD No-show', value: res.data.testDriveNoShowCount, path: '/testDriveFollowUp', query: 'TDNoShow' },
          //     { label: 'TD Follow Up', value: res.data.testDriveTdFollowupCount, path: '/testDriveFollowUp', query: 'TDFollowUp' }
          //   ]
          // },
          // {
          //   title: '客户跟进',
          //   span: 3,
          //   authCode: 'workbench-FollowUpTask',
          //   data: [
          //     { label: '客户动向', value: res.data.acountTrendCount, path: '/customerFollowUp', query: 'trend' },
          //     { label: '未进店', value: res.data.acountNo2shopCount, path: '/customerFollowUp', query: 'notInto' }
          //   ]
          // },
          // {
          //   title: '勘测跟进',
          //   span: 3,
          //   authCode: 'workbench-FollowUpTask',
          //   data: [
          //     { label: '勘测终止', value: res.data.surveyBreakOffCount, path: '/surveyFollowUp', query: 'termination' }
          //   ]
          // }
        ];
      } else {
        Toast(res.msg);
      }
    },
    // 获取战绩排名数据
    async getRankList() {
      const res = await getRank({
        currentIdentity: this.currentIdentity,
        dateRange: this.rankDate,
      });
      if (res.success) {
        this.rankList = [
          {
            title: "线索",
            total: res.data.increment.leads,
            rankName: "clue",
            data: [
              {
                label: "门店排名",
                value: res.data.ranking.leads
                  ? res.data.ranking.leads[this.rankDate]
                    ? res.data.ranking.leads[this.rankDate]["store"]
                      ? res.data.ranking.leads[this.rankDate]["store"][
                          "ranking"
                        ]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Store",
              },
              {
                label: "小区排名",
                value: res.data.ranking.leads
                  ? res.data.ranking.leads[this.rankDate]
                    ? res.data.ranking.leads[this.rankDate]["area"]
                      ? res.data.ranking.leads[this.rankDate]["area"]["ranking"]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Plot",
              },
              {
                label: "大区排名",
                value: res.data.ranking.leads
                  ? res.data.ranking.leads[this.rankDate]
                    ? res.data.ranking.leads[this.rankDate]["region"]
                      ? res.data.ranking.leads[this.rankDate]["region"][
                          "ranking"
                        ]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Region",
              },
              {
                label: "全国排名",
                value: res.data.ranking.leads
                  ? res.data.ranking.leads[this.rankDate]
                    ? res.data.ranking.leads[this.rankDate]["country"]
                      ? res.data.ranking.leads[this.rankDate]["country"][
                          "ranking"
                        ]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Nationwide",
              },
            ],
          },
          {
            title: "商机",
            total: res.data.increment.opp,
            rankName: "opp",
            data: [
              {
                label: "门店排名",
                value: res.data.ranking.opp
                  ? res.data.ranking.opp[this.rankDate]
                    ? res.data.ranking.opp[this.rankDate]["store"]
                      ? res.data.ranking.opp[this.rankDate]["store"]["ranking"]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Store",
              },
              {
                label: "小区排名",
                value: res.data.ranking.opp
                  ? res.data.ranking.opp[this.rankDate]
                    ? res.data.ranking.opp[this.rankDate]["area"]
                      ? res.data.ranking.opp[this.rankDate]["area"]["ranking"]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Plot",
              },
              {
                label: "大区排名",
                value: res.data.ranking.opp
                  ? res.data.ranking.opp[this.rankDate]
                    ? res.data.ranking.opp[this.rankDate]["region"]
                      ? res.data.ranking.opp[this.rankDate]["region"]["ranking"]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Region",
              },
              {
                label: "全国排名",
                value: res.data.ranking.opp
                  ? res.data.ranking.opp[this.rankDate]
                    ? res.data.ranking.opp[this.rankDate]["country"]
                      ? res.data.ranking.opp[this.rankDate]["country"][
                          "ranking"
                        ]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Nationwide",
              },
            ],
          },
          // {
          //   title: '意向金净增',
          //   total: res.data.increment.depositReserved,
          //   rankName: 'dr',
          //   data: [
          //     { label: '门店排名', value: res.data.ranking.depositReserved ? res.data.ranking.depositReserved[this.rankDate] ? res.data.ranking.depositReserved[this.rankDate]['store'] ? res.data.ranking.depositReserved[this.rankDate]['store']['ranking'] : 0 : 0 : 0, authCode: 'ScoreRanking-Store' },
          //     { label: '小区排名', value: res.data.ranking.depositReserved ? res.data.ranking.depositReserved[this.rankDate] ? res.data.ranking.depositReserved[this.rankDate]['area'] ? res.data.ranking.depositReserved[this.rankDate]['area']['ranking'] : 0 : 0 : 0, authCode: 'ScoreRanking-Plot' },
          //     { label: '大区排名', value: res.data.ranking.depositReserved ? res.data.ranking.depositReserved[this.rankDate] ? res.data.ranking.depositReserved[this.rankDate]['region'] ? res.data.ranking.depositReserved[this.rankDate]['region']['ranking'] : 0 : 0 : 0, authCode: 'ScoreRanking-Region' },
          //     { label: '全国排名', value: res.data.ranking.depositReserved ? res.data.ranking.depositReserved[this.rankDate] ? res.data.ranking.depositReserved[this.rankDate]['country'] ? res.data.ranking.depositReserved[this.rankDate]['country']['ranking'] : 0 : 0 : 0, authCode: 'ScoreRanking-Nationwide' }
          //   ]
          // },
          // {
          //   title: '大定净增',
          //   total: res.data.increment.order,
          //   rankName: 'order',
          //   data: [
          //     { label: '门店排名', value: res.data.ranking.order ? res.data.ranking.order[this.rankDate] ? res.data.ranking.order[this.rankDate]['store'] ? res.data.ranking.order[this.rankDate]['store']['ranking'] : 0 : 0 : 0, authCode: 'ScoreRanking-Store' },
          //     { label: '小区排名', value: res.data.ranking.order ? res.data.ranking.order[this.rankDate] ? res.data.ranking.order[this.rankDate]['area'] ? res.data.ranking.order[this.rankDate]['area']['ranking'] : 0 : 0 : 0, authCode: 'ScoreRanking-Plot' },
          //     { label: '大区排名', value: res.data.ranking.order ? res.data.ranking.order[this.rankDate] ? res.data.ranking.order[this.rankDate]['region'] ? res.data.ranking.order[this.rankDate]['region']['ranking'] : 0 : 0 : 0, authCode: 'ScoreRanking-Region' },
          //     { label: '全国排名', value: res.data.ranking.order ? res.data.ranking.order[this.rankDate] ? res.data.ranking.order[this.rankDate]['country'] ? res.data.ranking.order[this.rankDate]['country']['ranking'] : 0 : 0 : 0, authCode: 'ScoreRanking-Nationwide' }
          //   ]
          // },
          {
            title: "试乘试驾完成",
            total: res.data.increment.tdCompleted,
            rankName: "td",
            data: [
              {
                label: "门店排名",
                value: res.data.ranking.tdCompleted
                  ? res.data.ranking.tdCompleted[this.rankDate]
                    ? res.data.ranking.tdCompleted[this.rankDate]["store"]
                      ? res.data.ranking.tdCompleted[this.rankDate]["store"][
                          "ranking"
                        ]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Store",
              },
              {
                label: "小区排名",
                value: res.data.ranking.tdCompleted
                  ? res.data.ranking.tdCompleted[this.rankDate]
                    ? res.data.ranking.tdCompleted[this.rankDate]["area"]
                      ? res.data.ranking.tdCompleted[this.rankDate]["area"][
                          "ranking"
                        ]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Plot",
              },
              {
                label: "大区排名",
                value: res.data.ranking.tdCompleted
                  ? res.data.ranking.tdCompleted[this.rankDate]
                    ? res.data.ranking.tdCompleted[this.rankDate]["region"]
                      ? res.data.ranking.tdCompleted[this.rankDate]["region"][
                          "ranking"
                        ]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Region",
              },
              {
                label: "全国排名",
                value: res.data.ranking.tdCompleted
                  ? res.data.ranking.tdCompleted[this.rankDate]
                    ? res.data.ranking.tdCompleted[this.rankDate]["country"]
                      ? res.data.ranking.tdCompleted[this.rankDate]["country"][
                          "ranking"
                        ]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Nationwide",
              },
            ],
          },
          {
            title: "TD No-show",
            total: res.data.increment.tdNoShow,
            rankName: "noshow",
            data: [
              {
                label: "门店排名",
                value: res.data.ranking.tdNoShow
                  ? res.data.ranking.tdNoShow[this.rankDate]
                    ? res.data.ranking.tdNoShow[this.rankDate]["store"]
                      ? res.data.ranking.tdNoShow[this.rankDate]["store"][
                          "ranking"
                        ]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Store",
              },
              {
                label: "小区排名",
                value: res.data.ranking.tdNoShow
                  ? res.data.ranking.tdNoShow[this.rankDate]
                    ? res.data.ranking.tdNoShow[this.rankDate]["area"]
                      ? res.data.ranking.tdNoShow[this.rankDate]["area"][
                          "ranking"
                        ]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Plot",
              },
              {
                label: "大区排名",
                value: res.data.ranking.tdNoShow
                  ? res.data.ranking.tdNoShow[this.rankDate]
                    ? res.data.ranking.tdNoShow[this.rankDate]["region"]
                      ? res.data.ranking.tdNoShow[this.rankDate]["region"][
                          "ranking"
                        ]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Region",
              },
              {
                label: "全国排名",
                value: res.data.ranking.tdNoShow
                  ? res.data.ranking.tdNoShow[this.rankDate]
                    ? res.data.ranking.tdNoShow[this.rankDate]["country"]
                      ? res.data.ranking.tdNoShow[this.rankDate]["country"][
                          "ranking"
                        ]
                      : 0
                    : 0
                  : 0,
                authCode: "ScoreRanking-Nationwide",
              },
            ],
          },
        ];
      } else {
        Toast(res.msg);
      }
    },
    // 战绩排名天周月切换事件
    timeChange(item) {
      this.rankDate = item.label;
     this.getGetSalesFunnelStatistics({dateType: item.label})
    },
    // 跳转用户中心
    toPerson() {
      this.$router.push({
        path: "/person",
      });
    },
    // 跳转待分配页面
    unAllot(path) {
      this.$router.push({ path });
    },
    async getGetSalesFunnelStatistics(dateType) {
      const res = await getSalesFunnelStatistics(dateType);
      this.$nextTick(() => {
      
        this.myChart.setOption({
          series: [
            {
              name: "Funnel",
              type: "funnel",
              left: "10%",
              top: 60,
              bottom: 60,
              width: "80%",
              min: 0,
              max: Math.max(+res.data.leadsNum, +res.data.oppNum,  +res.data.orderNum),
              minSize: "0%",
              maxSize: "100%",
              sort: "descending",
              gap: 2,
              label: {
                show: true,
                position: "inside",
              },
              labelLine: {
                length: 10,
                lineStyle: {
                  width: 1,
                  type: "solid",
                },
              },
              itemStyle: {
                borderColor: "#fff",
                borderWidth: 1,
              },
              emphasis: {
                label: {
                  fontSize: 20,
                },
              },
              data: [
                { value: +res.data.leadsNum, name: "Leads: " +  (res.data.leadsNum)},
                { value: +res.data.oppNum, name: "Prospects: " + (res.data.oppNum)},
                { value: +res.data.orderNum, name: "Deposits: " + (res.data.orderNum) },
              ],
            },
          ],
        });
      });
    },
    init() {
      /* window.toast = Toast.loading({
        message: "Loading...",
        forbidClick: true,
        loadingType: "spinner",
      }); */

      this.curUser = this.$storage.get("userInfo");
      this.roleCode = this.$storage.get("roleCode");

      Promise.all([
        this.getUnDistribution(),
        this.getTaskNum(),
        this.getGetSalesFunnelStatistics({ dateType: 1 }),
      ]).finally(() => {
        this.loading = false;
        // window.toast.clear();
      });
    },
    bindingUserId() {
      this.$router.push({
        path: "/bindingUserId",
      });
    },
  },
  mounted() {
    this.myChart = echarts.init(document.getElementById("mainChart"));
    this.init();
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
/deep/ .van-badge--fixed {
  right: -20px;
  padding: 0.04rem 0.133333rem;
  font-size: 0.266667rem;
  white-space: nowrap;
}
</style>